import {
	dashboardAddBusinessData,
	type DashboardAddBusinessDataProps
} from '@/modules/dashboard/dashboardActions';
import type { RootState } from '@/rootReducer';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

export const useAddContactDataMutation = () => {
	const dispatch = useDispatch();

	const mutate = (contactData: DashboardAddBusinessDataProps) => {
		dispatch(dashboardAddBusinessData(contactData));
	};

	const [isLoading, isSuccess, isError] = useSelector<
		RootState,
		[boolean, boolean, boolean]
	>(
		state => [
			state.dashboard.getIn(['businesses', 'addedDataLoading']),
			state.dashboard.getIn(['businesses', 'addedDataSuccess']),
			state.dashboard.getIn(['businesses', 'addedDataFailure'])
		],
		shallowEqual
	);

	return { mutate, isLoading, isSuccess, isError };
};
